<template>
  <v-container grid-list-xs>
   <v-divider class="mt-12"></v-divider>
   
     <v-card
    class="mx-auto mt-12"
    color="white"
    width="300px"

  >
        <v-card-title class="mx-auto">
         <h5 class="mx-auto">INICIAR SESION</h5>
        </v-card-title>

        <v-card-text>
            <v-form
              ref="form"
              v-model="valid"
              lazy-validation
            >
            <v-text-field
                v-model="email"
                :rules="emailRules"
                label="E-mail"
                required
            ></v-text-field>

            <v-text-field
              v-model="pass"
              :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
              :type="show1 ? 'text' : 'password'"
              :rules="[rules.required, rules.min]"
              name="input-10-1"
              label="Contraseña"
              counter
              @click:append="show1 = !show1"
            ></v-text-field>
            </v-form>
              
        </v-card-text>

        <v-card-actions>
          <v-col>
            <v-btn
              block
              color="success"
              class="mr-4"
              @click.stop="agregar"
              >
              INICIAR SESION
            </v-btn>

            <v-btn block text small class="mt-3 blue--text  ">¿Registro nuevo?</v-btn>

          </v-col>

        </v-card-actions>

  </v-card>

          <v-snackbar
          v-model="snackbar"
          :timeout="timeout"
          top
        >
          USUARIO NO EXISTE
          <v-btn
            color="blue"
            text
            @click="snackbar = false"
          >
            Close
          </v-btn>
        </v-snackbar>

</v-container>

</template>

<script>
// @ is an alias to /src
import registrarUsuario from '@/components/registrarUsuario';
import { db } from '../db'
import firebase from 'firebase'


export default {
  name: 'login',

    components: {
    registrarUsuario,

  },
  data(){
    return{
      email: '',

      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
      ],
      pass:'',

      rules: {
          required: value => !!value || 'Required.',
          min: v => v.length >= 8 || 'Min 8 characters',
          emailMatch: () => ('The email and password you entered don\'t match'),
      },

      snackbar:false,
      timeout: 2000,

    }
  },

  methods: {
        agregar(){
                this.$refs.form.validate()
            if(this.pass!="" && this.email!=""){
              
                    firebase.auth().signInWithEmailAndPassword(this.email,this.pass)
                    .then(user =>{
                      console.info("Exito")
                      this.$router.push({name: 'gestionTienda'})
                    }).catch(err=>{
                      this.snackbar=true
                      console.info("error pass")
                    })
                }
        },
        validate () {
            this.$refs.form.validate()
        },
    },

}
</script>
